
import Vue from 'vue'
import SearchForm from './components/SearchForm.vue'
import ArticleList from './components/ArticleList.vue'
import Pagination from './components/Pagination.vue'
import ResultText from './components/ResultText.vue'

// Interfaces for component typechecking!

export default Vue.extend<{}, {}, {}, {}>({
	name: 'app',
	computed: {
	},
	methods: {
	},
	components: {
		SearchForm,
		ArticleList,
		Pagination,
		ResultText
	}
})
